export default __webpack_public_path__ + "static/media/p2p-banner.8f831cbf.webp";